import { Role } from '~/types';
import axios from '~/utils/axios';

export const deleteRole = (id: string) => {
  return axios.delete<void>(`/roles/${id}`).then((res) => res.data);
};

export const getAllRoles = () => {
  return axios.get<Role[]>(`/roles?page=1&perPage=999`).then((res) => res.data);
};

export const getPermissions = () => {
  return axios.get<string[]>(`/permissions`);
};
